import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedCommonModule } from 'app/back-office/shared/common.module';
import { DirectivesModule } from 'app/back-office/shared/directives/directives.module';
import { BadgeGeneratorModule } from 'app/back-office/shared/components/badge-generator/badge-generator.module';
import { PipesModule } from 'app/back-office/shared/pipes/pipes.module';
import { SearchBarModule } from 'app/back-office/shared/components/search-bar/search-bar.module';
import { CustomDateTimePickerModule } from 'app/back-office/shared/components/custom-date-time-picker/custom-date-time-picker.module';
import { TranslateModule } from '@ngx-translate/core';
import { UtilsService } from 'app/back-office/shared/services/core/utils.service';
import { CastToFormArrayModule } from 'app/shared/pipe/cast-to-form-array/cast-to-form-array.module';
import { LoaderModule } from 'app/shared/components/loader/loader.module';

import { BasicHttpClientService } from './services/basic-http-client.service';
import { LoaderService } from './services/loader.service';
import { NewOrderItemCustomQtyDateModule } from './components/new-order-item-custom-qty-date/new-order-item-custom-qty-date.module';

//TODO: analizzare l'eliminazione del/dei service dai providers
@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    OverlayModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    NgbModule,
    SharedCommonModule,
    DirectivesModule,
    LoaderModule,
    TranslateModule.forChild(),
    BadgeGeneratorModule,
    CastToFormArrayModule,
    CustomDateTimePickerModule,
    PipesModule,
    SearchBarModule,
    NewOrderItemCustomQtyDateModule,
  ],
  exports: [
    HttpClientModule,
    NewOrderItemCustomQtyDateModule
  ],
  providers: [
    BasicHttpClientService,
    UtilsService
  ],
})
export class CoreModule {
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        BasicHttpClientService,
        UtilsService,
        LoaderService
      ]
    };
  }
}
